export default {
  // SOLUTIONS
  'easy_patient_transportation': {
    heading: 'Easy patient transportation',
    description: 'Features like IV&Drive, i-Drive and Zerogap siderails improve ergonomics of the transport and make it more efficient',
    video: 'sprint/EasyPatienttransport.mp4'
  },
  'simplify_caregiver_procedures': {
    heading: 'Simplify caregiver procedures',
    description: "Intuitive to use and accessible, Sprint 200 helps the caregivers with their daily procedures like patient weighting.",
    video: 'sprint/SimplifyCaregiverprocedures.mp4'
  },
  'fall_prevention': {
    heading: 'Fall prevention',
    description: 'To prevent patient falls, Sprint 200 offers mobilization support, low height and bed exit alarm.',
    video: 'sprint/FallsPrevention.mp4'
  },
  'support_patient_recovery_improved_experience': {
    heading: 'Patient experience & recovery',
    description: "Sprint 200 offers multiple positions to help with patient's vital functions such as breathing.",
    video: 'sprint/PatientRecoveryImprovedExperience.mp4'
  },

  // KEY FEATURES
  'transportation': {
    heading: 'Transportation',
    subExplanations: [
      'idrive',
      'ivdrive',
      'easybrake',
      'zerogap_siderails',
    ]
  },
  'idrive': {
    heading: 'i-Drive power',
    description: 'Patient transport can present physical burden. With iDrive it is pushed to a new level. All it takes to drive Sprint 200 up to 11 km is a push of a button. It is further equipped with safety sensor so when the button stops registering the hand, the stretcher stops as well, bringing safety.',
    images: [
      'sprint/i-Drive_Power.jpg'
    ],
    camera: {
      orbit: '-5.72rad 1.22rad 20%',
      target: '80m 70m -80m'
    },
  },
  'ivdrive': {
    heading: 'IV&Drive',
    description: 'With innovative IV&Drive concept, IV poles and push handles are brought together. To push the stretcher from any height without compromising ergonomic posture. The IV poles also dont break under any standard circumstances.',
    images: [
      'sprint/IV_Drive.jpg'
    ],
    camera: {
      orbit: '-4.72rad 1.475rad 40%',
      target: '0 0 0'
    },
  },
  'easybrake': {
    heading: 'EasyBrake',
    description: 'To improve braking and steering, EasyBrakes are always visible and can be reached from all four sides.',
    images: [
      'sprint/EasyBrake.jpg'
    ],
    camera: {
      orbit: '-10.11rad 1.31rad 33%',
      target: '-100m 10m 0'
    },
  },
  'zerogap_siderails': {
    heading: 'Zerogap siderails',
    description: 'Lateral movement of a patient is often a difficult task. Thanks to zerogap principle, siderails help caregivers to do so safely and smoothly.',
    images: [
      'sprint/ZeroGap.jpg'
    ],
    camera: {
      orbit: '-6.89rad 1.41rad 40%',
      target: '0 0 0'
    },
  },

  'safety': {
    heading: 'Safety',
    subExplanations: [
      'bed_exit_alarm',
      'softdrop_siderails',
      'mobilift',
      'ergoframe',
      'mobigrips',
      'infection_control',
    ]
  },
  'bed_exit_alarm': {
    heading: 'Bed exit alarm',
    description: 'Bed Exit Monitoring system monitors patient´s presence in bed and triggers alarms based on defined zone. Inner zone - triggers alarm when patient is moving or going to leave. Outer zone - trigger alarms when patient left the bed.',
    images: [
      'sprint/Bed_Exit_Alarm.jpg'
    ],
    camera: {
      orbit: '-1.58rad 0.897rad 33%',
      target: '-10m 0m 0m'
    },
  },
  'softdrop_siderails': {
    heading: 'Softdrop siderails',
    description: 'Siderails secure the patient from falling out without compromizing access and can handle even the most difficult treatment. Siderails are further equipped with SoftDrop function to prevent hand entrapment.',
    images: [
      'sprint/Softdrop_siderails.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-30m 60m -20m'
    },
  },
  'mobilift': {
    heading: 'Mobi-lift',
    description: 'When leaving the stretcher, patient is in increased risk of fall without support. The Mobilift handle can provide support for the patient.',
    images: [
      'sprint/Mobi-Lift.jpg'
    ],
    camera: {
      orbit: '-6.89rad 1.41rad 40%',
      target: '-10m 60m -40m'
    },
  },
  'ergoframe': {
    heading: 'Ergoframe',
    description: 'To help the patient feel comfortable during positioning, Ergoframe reduces the peak pressure in pelvis area by 16%.',
    images: [
      'sprint/Ergoframe.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-30m 60m -20m'
    },
  },
  'mobigrips': {
    heading: 'Mobigrips',
    description: 'The unique integrated Mobigrip in the siderails can help the patient with self-mobilization in stretcher, preventing immobilization which can lead to increased risk of pressure injury development.',
    images: [
      'sprint/Mobi-Grips.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-60m 70m 20m'
    },
  },
  'infection_control': {
    heading: 'Infection control',
    description: 'With columns design, smooth surfaces and accessible undercarriage, Sprint 200 is easy to clean and maintain.',
    images: [
      'sprint/Infection_Control.jpg'
    ],
    camera: {
      orbit: '-5.90rad 1.19rad 30%',
      target: '75m 25m 0m'
    },
  },

  'additional_controls': {
    heading: 'Additional controls',
    subExplanations: [
      'foot',
      'mattress_platform_controls',
      'scales'
    ],
  },
  'foot': {
    heading: 'Foot controls',
    description: 'The hydraulic foot controls are intuitive and accessible to position the stretcher even in most challenging circumstances.',
    images: [
      'sprint/Foot_Controls.jpg'
    ],
    camera: {
      orbit: '-6.92rad 0.94rad 30%',
      target: '20m -10m 0m'
    },
  },
  'mattress_platform_controls': {
    heading: 'Mattress platform controls',
    description: 'Mattress controls allow for easy adjustment of the stretcher.',
    images: [
      'sprint/Mattress_Platform_Controls.jpg'
    ],
    camera: {
      orbit: '-5.67rad 0.96rad 30%',
      target: '50m 20m -30m'
    },
  },
  'scales': {
    heading: 'Scales',
    description: 'Scales with a precision od 0.5 kg help caregivers to make more accurate decisions immediately without a need to move the patient.',
    images: [
      'sprint/Scales.jpg'
    ],
    camera: {
      orbit: '-1.58rad 0.897rad 33%',
      target: '-10m 0m 0m'
    },
  },

  'positions': {
    heading: 'Positions',
    subExplanations: [
      'cardiac',
      'vascular_leg',
      'trendelenburg',
      'anti-trendelenburg',
      'semi-fowler'
    ]
  },
  'cardiac': {
    heading: 'Cardiac chair',
    description: 'While staying on the stretcher it is vital to make the patient comfortable. The Cardiac chair position improves the patient’s breathing and cardiovascular functions.',
    images: [
      'sprint/Cardiac_chair.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'vascular_leg': {
    heading: 'Vascular leg',
    description: '',
    images: [
      'sprint/Vascular_leg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'trendelenburg': {
    heading: 'Trendelenburg',
    description: '',
    images: [
      'sprint/Trendelenburg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'anti-trendelenburg': {
    heading: 'Anti-trendelenburgg',
    description: '',
    images: [
      'sprint/Anti-Trendelenburg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'semi-fowler': {
    heading: 'Semi-fowler',
    description: '',
    images: [
      'sprint/Semi_Fowler.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },

  'mattress_options': {
    heading: 'Mattress options',
    subExplanations: [
      'standart',
      'comfort',
      'advanced',
      'reactive'
    ]
  },
  'standart': {
    heading: 'Standart',
    description: '1-layer mattress for short stays, offering standard level of patient support.',
    images: [
      'sprint/standard_0000.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'comfort': {
    heading: 'Comfort',
    description: '2-layer mattress with improved heel comfort and higher level of patient support.',
    images: [
      'sprint/comfort_0001.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'advanced': {
    heading: 'Advanced',
    description: '4-layer mattress with protective cover for patients with reduced mobility.',
    images: [
      'sprint/advanced_0001.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'reactive': {
    heading: 'Reactive',
    description: 'Mattress with pressure redistribution offering high level of comfort for patients with risk of pressure injuries.',
    images: [
      'sprint/reactive_0001.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },

  'accessories': {
    heading: 'Accessories',
    subExplanations: [
      '3-in-1_shelf',
      'vertical_oxygen_bottle_holder',
      'paper_roll_holder',
      'notes_holder',
      'multifunctional_box'
    ]
  },
  '3-in-1_shelf': {
    heading: '3-in-1 shelf',
    description: '',
    images: [
      'sprint/3-in-1_Shelf.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'vertical_oxygen_bottle_holder': {
    heading: 'Vertical oxygen bottle holder',
    description: '',
    images: [
      'sprint/Vertical_oxygen_bottle_holder.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'paper_roll_holder': {
    heading: 'Paper roll holder',
    description: '',
    images: [
      'sprint/Paper_roll_holder.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'notes_holder': {
    heading: 'Notes holder',
    description: '',
    images: [
      'sprint/Notes_holder.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'multifunctional_box': {
    heading: 'Multifunctional box',
    description: '',
    images: [
      'sprint/Multidunctional_box.jpg'
    ],
    camera: {
      orbit: '-2.63rad 1.60rad 30%',
      target: '75m 50m 30m'
    },
  },
}
